"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TransitionablePortal["default"];
  }
});

var _TransitionablePortal = _interopRequireDefault(require("./TransitionablePortal"));


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/addons/TransitionablePortal/index.js
// module id = 641
// module chunks = 0